import { GuestControl } from '../../models/form/wizard-form.model';
import { ValidatorFn, Validators, FormControl } from '@angular/forms';
import { InjectorService } from 'src/app/shared/services/injector/injector.service';
import { ConfigService } from 'src/app/shared/services/config/config.service';
import { EControls } from '../../enums/controls.enum';
import { whiteSpaceValidator } from 'src/app/shared/validators';

export class FormValidators {
  private countryCode: string;

  constructor() {
    this.countryCode = InjectorService.get().get(ConfigService).booking.acc.country.code;
  }

  public get(control: GuestControl): { pattern?: string; validators: ValidatorFn[]; } {
    const validators: ValidatorFn[] = control.required ? [
      Validators.required,
      ...(control.type === 'TEXT' || control.type === 'AUTOSUGGEST') ? [whiteSpaceValidator] : []
    ] : [];

    switch (control.id) {
      case EControls.clientEmail:
        return { validators: [...validators, Validators.email] };
      case EControls.clientName:
      case EControls.clientFirstSurname:
      case EControls.clientSecondSurname:
        if (this.countryCode === 'ES') {
          validators.push(Validators.pattern('[a-zA-ZáéíóúÁÉÍÓÚçÇñÑ ]*'));
        }
        return {
          validators,
          ...(this.countryCode === 'ES') && { pattern: '[^a-zA-ZáéíóúÁÉÍÓÚçÇñÑ ]' }
        };
      default:
        return { validators };
    }
  }

  public idValidator: ValidatorFn = (fc: FormControl) => {
    return /^[a-zA-Z0-9]{5,20}$/.test(fc.value) ? null : { documentIdPatternError: true };
  }

  public passportValidator: ValidatorFn = (fc: FormControl) => {
    return /^[a-zA-Z0-9]{5,14}$/.test(fc.value) ? null : { documentPassportPatternError: true };
  }

  public spanishIdValidator: ValidatorFn = (fc: FormControl) => {
    const { value = '' } = fc;
    const match = value.trim().match(new RegExp('^([xyzZYX])?([0-9]{7,8})([a-zA-Z])$'));

    if (match) {
      const [_, prefix = '0', n, letter = ''] = match;
      const pre = prefix.replace('X', '0').replace('Y', '1').replace('Z', '2');
      const index = Number(`${pre}${n}`) % 23;

      if ('TRWAGMYFPDXBNJZSQVHLCKET'[index] === letter.toUpperCase()) {
        return null;
      }
    }

    return { documentIdPatternError: true };
  }
}
